export enum LoanStatusEnum{
    New = 0,
    Rejected = 1,
    In_Review = 2,
    Approved = 3,
    Funded = 4,
    Declined = 5,
    Expired = 7,
    Removed = 8
}